export default __webpack_public_path__ + "static/carmokun-cmbanner-e123f17e1cd6f3a4e3d81695f9cbc53b.avif";